import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./FarewellPage.css";

const TARGET_TIME = new Date("2026-06-06T16:00:00-04:00");

const COPY = {
  en: {
    eyebrow: "Farewell",
    title: "The wedding is over. The love goes on.",
    subtitle: "Counting up from June 6, 2026 at 4:00 PM New York time.",
    note: "June 6, 2026, 4:00 PM - New York",
    labels: ["Days", "Hours", "Minutes", "Seconds"],
    ariaLabel: "Elapsed time since June 6, 2026 at 4:00 PM New York time",
    languageLabel: "РУ",
    languageHref: "/ru",
  },
  ru: {
    eyebrow: "Прощание",
    title: "Свадьба прошла. Любовь продолжается.",
    subtitle: "Счет идет с 6 июня 2026 года, 16:00 по времени Нью-Йорка.",
    note: "6 июня 2026, 16:00 - Нью-Йорк",
    labels: ["Дней", "Часов", "Минут", "Секунд"],
    ariaLabel: "Прошедшее время с 6 июня 2026 года, 16:00 по времени Нью-Йорка",
    languageLabel: "EN",
    languageHref: "/",
  },
};

function getElapsedParts(now) {
  const totalSeconds = Math.max(0, Math.floor((now.getTime() - TARGET_TIME.getTime()) / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days,
    hours,
    minutes,
    seconds,
  };
}

function FarewellPage({ locale = "en" }) {
  const [now, setNow] = useState(() => new Date());
  const copy = COPY[locale] ?? COPY.en;
  const backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(9, 7, 6, 0.25) 0%, rgba(9, 7, 6, 0.65) 100%), url(${process.env.PUBLIC_URL}/images/couple_photos/IMG_Final.jpeg)`,
  };

  useEffect(() => {
    const tick = () => setNow(new Date());
    tick();
    const intervalId = window.setInterval(tick, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  const elapsed = getElapsedParts(now);

  return (
    <main className="farewell-page">
      <div className="farewell-page__background" aria-hidden="true" style={backgroundStyle} />
      <div className="farewell-page__overlay" aria-hidden="true" />

      <section className="farewell-page__content">
        <div className="farewell-card">
          <div className="farewell-card__header">
            <p className="farewell-card__eyebrow"></p>
            <Link className="farewell-card__language-link" to={copy.languageHref}>
              {copy.languageLabel}
            </Link>
          </div>
          <h1 className="farewell-card__title">{copy.title}</h1>

          <div className="farewell-timer" aria-live="polite" aria-label={copy.ariaLabel}>
            <div className="farewell-timer__cell">
              <span className="farewell-timer__value">{String(elapsed.days).padStart(2, "0")}</span>
              <span className="farewell-timer__label">{copy.labels[0]}</span>
            </div>
            <div className="farewell-timer__cell">
              <span className="farewell-timer__value">{String(elapsed.hours).padStart(2, "0")}</span>
              <span className="farewell-timer__label">{copy.labels[1]}</span>
            </div>
            <div className="farewell-timer__cell">
              <span className="farewell-timer__value">{String(elapsed.minutes).padStart(2, "0")}</span>
              <span className="farewell-timer__label">{copy.labels[2]}</span>
            </div>
            <div className="farewell-timer__cell">
              <span className="farewell-timer__value">{String(elapsed.seconds).padStart(2, "0")}</span>
              <span className="farewell-timer__label">{copy.labels[3]}</span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default FarewellPage;